// (function () {
//     'use strict';
//
//     angular
//         .module('fauzanKhanQueryBuilder')
//         .directive('qbEditBracket', qbEditBracket);
//
//     function qbEditBracket() {
//         return {
//             restrict: 'E',
//             controller: qbEditBracketCtrl,
//             controllerAs: 'qb',
//             bindToController: true
//         };
//     }
//
//     function qbEditBracketCtrl() {
//         var vm = this;
//
//     }
// })();